module.exports = __webpack_public_path__ + "img/pricing.901330c2.webp";